module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('mu-tabs', {
    attrs: {
      "value": _vm.activeTab
    },
    on: {
      "change": _vm.handleTabChange
    }
  }, [_c('mu-tab', {
    attrs: {
      "value": "search",
      "icon": "search",
      "title": "搜索"
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "movies",
      "icon": "restore",
      "title": "电影"
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "tvplays",
      "icon": "favorite",
      "title": "电视剧"
    }
  })], 1), _vm._v(" "), _c('transition', [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ac312672"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 52
// module chunks = 1